/**
 * PDA — recalcule la hauteur du panneau mega quand un accordéon « Avancés » s'ouvre/ferme.
 *
 * header-menu.js ne mesure `--submenu-height` / `--full-open-header-height` qu'à
 * l'ACTIVATION du panneau (accordéons fermés), et son MutationObserver n'observe que
 * { childList, subtree } — or ouvrir un <details> est un changement d'ATTRIBUT (`open`) +
 * un event `toggle`, NON observés. Sans recalcul, le contenu déplié déborde le clip-path
 * de .menu-list__submenu et se fait couper. On remesure ici au `toggle`, en répliquant
 * exactement le calcul de header-menu.js (#setFullOpenHeaderHeight).
 *
 * `toggle` ne bulle pas → on écoute en phase de CAPTURE sur le document.
 */
(() => {
  if (window.__pdaMegaAccInit) return;
  window.__pdaMegaAccInit = true;

  const recompute = (submenu) => {
    if (!submenu) return;
    const header = document.querySelector('#header-component');
    if (!header) return;
    // double rAF : laisse le reflow du <details> s'appliquer avant la mesure
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        // Garde de fraîcheur (fix race de fermeture) : si le mega s'est refermé pendant
        // ces 2 frames (dé-survol rapide / switch d'item), header-menu.js a DÉJÀ remis les
        // hauteurs à 0 et aria-expanded à false. Réécrire ici rouvrirait un underlay blanc
        // fantôme — car un submenu `visibility:hidden` garde offsetHeight > 0, donc la garde
        // `h <= 0` ne protège PAS. On ne réécrit QUE si le panneau est ENCORE ouvert.
        const li = submenu.closest('.menu-list__list-item');
        if (!li || !li.querySelector('.menu-list__link[aria-expanded="true"]')) return;
        const h = submenu.offsetHeight;
        if (h <= 0) return;
        header.style.setProperty('--submenu-height', `${h}px`);
        const isOverlap = header.hasAttribute('data-submenu-overlap-bottom-row');
        const headerVisible = isOverlap
          ? header.querySelector('.header__row--top')?.offsetHeight ?? 0
          : header.offsetHeight;
        header.style.setProperty('--full-open-header-height', `${h + headerVisible}px`);
      })
    );
  };

  document.addEventListener(
    'toggle',
    (e) => {
      const acc = e.target;
      if (!(acc instanceof HTMLElement) || !acc.classList.contains('pda-mega__acc')) return;
      recompute(acc.closest('.menu-list__submenu'));
    },
    true
  );

  // PDA #3a : re-mesure la hauteur du panneau à l'OUVERTURE d'un mega-menu. header-menu.js lit
  // submenu.offsetHeight de façon synchrone à l'activation ; sur du contenu statique
  // (content-visibility) il peut lire 0 → panneau à hauteur 0 alors que aria-expanded est déjà
  // posé (nav sombre, panneau invisible). Quand aria-expanded passe à true, on re-mesure en
  // double-rAF (recompute bail si ≤ 0). Idempotent, ne réécrit que les 2 vars de hauteur.
  const header = document.querySelector('#header-component');
  if (header) {
    new MutationObserver((muts) => {
      for (const m of muts) {
        const el = m.target;
        if (
          el instanceof HTMLElement &&
          el.classList.contains('menu-list__link') &&
          el.getAttribute('aria-expanded') === 'true'
        ) {
          recompute(el.closest('.menu-list__list-item')?.querySelector('.menu-list__submenu'));
        }
      }
    }).observe(header, { subtree: true, attributes: true, attributeFilter: ['aria-expanded'] });
  }
})();
